import React from 'react';
import { Redirect, Route } from 'react-router';
import { Props } from 'routes/types';
import { mapAvailablePageToBackendPermittedPage } from 'utils/user/permissions';
import { getPage } from 'routes/pageProvider';
import { getPageMap } from 'routes/routeMapProvider';
import { decoratePageComponentWithPermission } from 'routes/permittedPageComponentDecorator';
import { login } from 'routes/routePaths';
import permissionService from 'routes/permissionService';
import { getLayoutFromComponent, LayoutProvider } from 'layouts/LayoutProvider';

const PublicRoute: React.FC<Props> = ({
  routeGroup,
  elseRoute = login,
  pageName,
  exact = false,
  user,
  isLogged,
  ...rest
}: Props) => {
  try {
    const permissionGroup = permissionService.createPermissionGroup(
      user,
      pageName,
      mapAvailablePageToBackendPermittedPage(routeGroup, pageName),
    );
    const page = getPage(getPageMap(routeGroup), permissionGroup);
    const pageWithPermission = page ? decoratePageComponentWithPermission(page, permissionGroup.permission) : page;

    return (
      <LayoutProvider layout={getLayoutFromComponent(page)}>
        <Route component={pageWithPermission} {...rest} exact={exact} />
      </LayoutProvider>
    );
  } catch (e) {
    return <Redirect to={elseRoute} />;
  }
};

export default PublicRoute;
